import config from '../../../config';

const TILE_SIZE = config.TILE_SIZE;

function initZapperWalls (layer) {
  let g = this.g;

  let triggers = [];
  let highlights = [];

  _.each(layer.groups.tiles, (sprite) => {
    let nameArray = sprite.frame.name.split('-');
    let direction = nameArray.slice(2, 3)[0];
    let section = nameArray.pop().replace('.png', '');
    let startFrame;
    let wall = g.add.sprite(sprite.x, sprite.y, 'wall-charge');
    wall.resetY = sprite.resetY;
    sprite.setVisible(false);
    sprite.setActive(false);

    if (section === 'mid') {
      startFrame = g.anims.get('wall-charge-mid').frames[0].frame.name;
      wall.animKey = 'wall-charge-mid';
    } else {
      startFrame = g.anims.get('wall-charge-end').frames[0].frame.name;
      wall.animKey = 'wall-charge-end';
    }
    wall.setFrame(startFrame);
    wall.setScale(0.5);

    let zap = g.add.sprite(sprite.x, sprite.y, 'electric-spikes');
    zap.resetY = sprite.resetY;
    zap.animKey = section === 'mid' ? 'electric-spikes-mid' : 'electric-spikes-end';
    let hit = { x: sprite.x, y: sprite.resetY, width: TILE_SIZE, height: TILE_SIZE };
    zap.hit = hit;
    switch (direction) {
      case config.LEFT:
        hit.x -= TILE_SIZE;
        wall.angle = 180;
        zap.angle = 180;
        if (section === 'bottom') {
          wall.setScale(0.5, -0.5);
          zap.setScale(1, -1);
        }
        break;
      case config.RIGHT:
        hit.x += TILE_SIZE;
        if (section === 'top') {
          wall.setScale(0.5, -0.5);
          zap.setScale(1, -1);
        }
        break;
      case config.DOWN:
        hit.y += TILE_SIZE;
        wall.angle = 90;
        zap.angle = 90;
        if (section === 'right') {
          wall.setScale(0.5, -0.5);
          zap.setScale(1, -1);
        }
        break;
      case config.UP:
        hit.y -= TILE_SIZE;
        wall.angle = 270;
        zap.angle = 270;
        if (section === 'left') {
          wall.setScale(0.5, -0.5);
          zap.setScale(1, -1);
        }
        break;
    }

    highlights.push(wall);
    triggers.push(zap);
  });

  layer.groups.triggers = triggers;
  layer.groups.highlights = highlights;
}

export {
  initZapperWalls
};
